import {request} from "../request/request";

const documentType = {
  getAll: () => request.read('/document-type', null, true),
};

export {documentType};